import { SnackbarOrigin, SnackbarProvider } from 'notistack';
import React, { useMemo } from 'react';

import { useWindowDimensions } from 'hooks/common';
import PendoProvider from 'providers/PendoProvider';
import PusherProvider from 'providers/PusherProvider';
import { SESSION_STORAGE_URL } from '../constants/sessionStorage';
import ReduxProvider from './ReduxProvider';
import SignalRProvider from './SignalRProvider';
import ThemeProvider from './ThemeProvider';
import ValidationDictionaryProvider from './ValidationDictionaryProvider';
import useStyles from './styles';

interface IProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<IProps> = ({ children }) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const url = sessionStorage.getItem(SESSION_STORAGE_URL);

  const anchorOrigin: SnackbarOrigin = useMemo(
    () => ({
      horizontal: url && !url.includes('halo') ? 'left' : 'right',
      vertical: 'bottom',
    }),
    [url],
  );

  const snackCount = useMemo(() => (width < 400 ? 1 : 2), [width]);
  return (
    <SnackbarProvider
      maxSnack={snackCount}
      autoHideDuration={2000}
      anchorOrigin={anchorOrigin}
      preventDuplicate
      className={classes.snackbar}
    >
      <ReduxProvider>
        <PendoProvider>
          <ThemeProvider>
            <SignalRProvider>
              <PusherProvider>
                <ValidationDictionaryProvider>{children}</ValidationDictionaryProvider>
              </PusherProvider>
            </SignalRProvider>
          </ThemeProvider>
        </PendoProvider>
      </ReduxProvider>
    </SnackbarProvider>
  );
};

export default AppProviders;
